import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { PAIN_POINTS } from '../../data/content';
export function Problems() {
  return <section className="bg-crema py-16 sm:py-20 px-5" data-id="element-220" data-mp="17z8or3euelio">
      <div className="max-w-5xl mx-auto" data-id="element-221" data-mp="1czd8d2b1rwd4">
        <h2 className="font-serif text-3xl sm:text-4xl font-bold text-violeta text-center max-w-3xl mx-auto leading-tight" data-id="element-222" data-mp="1d0fwj2gzjkpc">
          Si algo de esto te pasa, ya sabés de qué estamos hablando
        </h2>

        <ul className="mt-10 grid gap-4 sm:gap-5 md:grid-cols-2" data-id="element-223" data-mp="kd28xuz6g1hw">
          {PAIN_POINTS.map(punto => <li key={punto} className="flex items-start gap-4 rounded-2xl bg-white border border-crema-alt p-5 shadow-sm" data-id="element-224" data-mp="p87swo90r63c">
              <XCircleIcon className="w-6 h-6 text-coral shrink-0 mt-0.5" aria-hidden="true" data-id="element-225" data-mp="z16rmyy8cd0o" />
              <p className="text-base sm:text-lg leading-snug text-tinta" data-id="element-226" data-mp="1jom6d5mb1dd">{punto}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}